var map = {
	"./bonneproj.png": 3988,
	"./chaostheory.png": 4423,
	"./cliffordtorus.png": 6763,
	"./dandelin.png": 8908,
	"./doubleslit.png": 1471,
	"./goldenratio.png": 2712,
	"./hyptiling.png": 3502,
	"./lotkavolterra.png": 4923,
	"./mandelbrot.png": 1814,
	"./mandelorbits.png": 6770,
	"./newtonfractal.png": 7589,
	"./newtonparams.png": 3729,
	"./pedalcurves.png": 2072,
	"./pendsim.png": 5614,
	"./quadformula.png": 9266,
	"./spirograph.png": 784,
	"./steiner.png": 9641,
	"./stellations.png": 1884,
	"./vivianithm.png": 8331,
	"./waveeqn.png": 6473,
	"./wittgensteinrod.png": 7303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7671;